import axios from "axios";

// default
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

let isRefreshing = false;
let failedQueue = [];

// token
const token = JSON.parse(localStorage.getItem("authUser"))
  ? JSON.parse(localStorage.getItem("authUser")).accessToken
  : null;
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;
axios.defaults.headers.common["Identity"] = "Control Panel";
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (err) => {
    const originalRequest = err.config;
    if (originalRequest.url.indexOf("/api/auth/user/session/refresh") > -1) {
      localStorage.clear();
      window.location.reload();
      return;
    }
    if (originalRequest.url != "/api/auth/sign-in" && err.response) {
      if (err.response.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // if already refreshing, push the failed request in queue
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers["Authorization"] = "Bearer " + token;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        // refreshing token
        return new Promise(async function (resolve, reject) {
          var refreshToken = JSON.parse(localStorage.getItem("authUser"))
            ? JSON.parse(localStorage.getItem("authUser")).refreshToken
            : null;
          if (!refreshToken) {
            await authContext.logout();
            return;
          }
          axios
            .post(
              `${process.env.REACT_APP_API_URL}/api/auth/user/session/refresh`,
              {
                refreshToken: refreshToken,
              }
            )
            .then(async ({ data }) => {
              localStorage.setItem("authUser", JSON.stringify(data));
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + data.accessToken;
              originalRequest.headers["Authorization"] =
                "Bearer " + data.accessToken;
              processQueue(null, data.accessToken);
              resolve(axios(originalRequest));
            })
            .catch(async (err) => {
              processQueue(err, null);
              await authContext.logout();
              reject(err);
            })
            .then(async () => {
              isRefreshing = false;
            });
        });
      }
    }
    return Promise.reject(err?.response?.data?.message);
  }
);

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class HttpClient {
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   *
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * post given data to url
   */
  uploadFile = (url, data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("file", data);
    return axios.post(url, bodyFormData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };

  patch = (url, data) => {
    return axios.patch(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedInUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { HttpClient, setAuthorization, getLoggedInUser };
